"use strict";
'use es6';

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireWildcard(require("react"));

var _utils = require("../../utils");

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var tracker = _interopRequireWildcard(require("ui-addon-upgrades/_core/common/eventTracking/tracker"));

var _Promptable = _interopRequireDefault(require("UIComponents/decorators/Promptable"));

var _UpgradeProductProperties = _interopRequireDefault(require("self-service-api/constants/UpgradeProductProperties"));

var _upgradeDataPropsInterface = require("ui-addon-upgrades/_core/common/data/upgradeData/interfaces/upgradeDataPropsInterface");

var _TrialPropsInterface = require("ui-addon-upgrades/_core/trial/TrialPropsInterface");

var _AdminOnlyWrapper = _interopRequireDefault(require("ui-addon-upgrades/_core/common/components/AdminOnlyWrapper"));

var _AdminTypes = require("ui-addon-upgrades/_core/common/constants/AdminTypes");

var _AdminModalTypes = require("ui-addon-upgrades/_core/common/constants/AdminModalTypes");

var _TrialActivationModalContainer = _interopRequireDefault(require("../common/components/TrialActivationModalContainer"));

var _UILoadingButton = _interopRequireDefault(require("UIComponents/button/UILoadingButton"));

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var CLICK_DELAY = 50;

function sequence() {
  for (var _len = arguments.length, handlers = new Array(_len), _key = 0; _key < _len; _key++) {
    handlers[_key] = arguments[_key];
  }

  return function () {
    for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
      args[_key2] = arguments[_key2];
    }

    handlers.forEach(function (handler) {
      return handler && handler.apply(void 0, args);
    });
  };
}

var trialActivationPrompt = (0, _Promptable.default)(_TrialActivationModalContainer.default);

var TrialActivationButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2.default)(TrialActivationButton, _Component);

  function TrialActivationButton() {
    var _this;

    (0, _classCallCheck2.default)(this, TrialActivationButton);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(TrialActivationButton).call(this));
    _this.state = {
      showActivationModalContainer: false
    };
    _this.debouncedHandleClick = (0, _utils.debounce)(_this.handleClick.bind((0, _assertThisInitialized2.default)(_this)), CLICK_DELAY);
    return _this;
  }

  (0, _createClass2.default)(TrialActivationButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var upgradeData = this.props.upgradeData;
      tracker.track('trialActivationButtonInteraction', (0, _extends2.default)({
        action: 'viewed'
      }, upgradeData));
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          upgradeData = _this$props.upgradeData,
          shouldHideSurvey = _this$props.shouldHideSurvey,
          onSuccess = _this$props.onSuccess,
          successModalHeader = _this$props.successModalHeader,
          successModalSubText = _this$props.successModalSubText;
      trialActivationPrompt({
        upgradeData: upgradeData,
        shouldHideSurvey: shouldHideSurvey,
        onSuccess: onSuccess,
        successModalHeader: successModalHeader,
        successModalSubText: successModalSubText
      });
      tracker.track('trialActivationButtonInteraction', (0, _extends2.default)({
        action: 'clicked'
      }, upgradeData));
      this.setState({
        showActivationModalContainer: true
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          _this$props2$upgradeD = _this$props2.upgradeData,
          trialId = _this$props2$upgradeD.trialId,
          upgradeProduct = _this$props2$upgradeD.upgradeProduct,
          onClick = _this$props2.onClick;
      var showActivationModalContainer = this.state.showActivationModalContainer;
      var onClickSequence = sequence(this.debouncedHandleClick, onClick);
      var propsToPass = (0, _utils.omit)(this.props, ['onClick', 'upgradeData', 'onSuccess', 'shouldHideSurvey', 'trialId', 'allowModal', 'successModalHeader', 'successModalSubText']);
      if (!trialId) return null;
      return _react.default.createElement(_AdminOnlyWrapper.default, {
        adminType: _AdminTypes.TEAM,
        modalType: _AdminModalTypes.REQUEST_TRIAL,
        merchandiseId: _UpgradeProductProperties.default[upgradeProduct].merchandiseId
      }, propsToPass.use && propsToPass.use.includes('link') ? _react.default.createElement(_UIButton.default, (0, _extends2.default)({}, propsToPass, {
        onClick: onClickSequence,
        "data-selenium": "trial-button",
        "data-reagan-primary-cta": true
      }), _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.trialActivationButton." + upgradeProduct
      })) : _react.default.createElement(_UILoadingButton.default, (0, _extends2.default)({}, propsToPass, {
        onClick: onClickSequence,
        "data-selenium": "trial-button",
        "data-reagan-primary-cta": true,
        loading: showActivationModalContainer
      }), _react.default.createElement(_FormattedMessage.default, {
        message: "upgrades.trialActivationButton." + upgradeProduct
      })));
    }
  }]);
  return TrialActivationButton;
}(_react.Component);

TrialActivationButton.defaultProps = {
  use: 'primary',
  onClick: function onClick() {}
};
TrialActivationButton.propTypes = (0, _extends2.default)({}, _upgradeDataPropsInterface.upgradeDataPropsInterface, _TrialPropsInterface.TrialActivationButtonPropsInterface, {
  onClick: _react.PropTypes.func
});
var _default = TrialActivationButton;
exports.default = _default;
module.exports = exports.default;